((HomepageSlidersTabs, $) => {

  const $dom = {};
  const breakpoint = 749;
  let shopyBySlidersAreMobile = window.innerWidth <= breakpoint ? true: false;

  const heroSliderOptions = {
    autoplay: false,
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    fade: true
  }

  const shopSliderOptions = {
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 749,
        settings: "unslick"
      }
    ]
  }

  const reviewsSliderOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false
  }

   const blogSliderOptions = {
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  const handleTabClick = (event) => {
    event.preventDefault();
    const tabElement = $(event.currentTarget);
    const dataId = $(tabElement).data('shop-link-id');
    const collectionHandle = $(tabElement).data('collection-handle');
    const tabText = $(tabElement).text().trim();

    // remove active class from previous tab + add to current
    $('.js-homepage-shop-categories-tab').removeClass('active');
    $(tabElement).addClass('active');

    // show corresponding product slider
    $('.js-homepage-shop-categories-product-container').each(function() {
      const el = $(this);

      if (el.attr('id') == dataId) {
        el.show();
        $('.js-homepage-shop-categories-product-slider-container').slick('setPosition');
      } else {
        el.hide();
      }
    });

    updateShopAllButton(tabElement, collectionHandle, tabText);
  }

  const updateShopAllButton = (tabElement, collectionHandle, tabText) => {
    // shop all products condition
    if ($(tabElement).hasClass('js-shop-all-tab')) {
      tabText = 'Products';
    }
    // set text and link
    $('.homepage-shop-all-button').text(`All ${tabText}`);
    $('.homepage-shop-all-button').attr('href', `/collections/${collectionHandle}`);
  }

  const initTabsAndShopAllButton = () => {
    // set first tab as active + set 'all' button to match collection
    let initialTab = $('.js-homepage-shop-categories-tab').first();
    let initialTabText = initialTab.text().trim();
    let initialCollection = initialTab.data('collection-handle');
    initialTab.addClass('active');

    updateShopAllButton(initialTab, initialCollection, initialTabText);
  }
    
  const bindUIActions = () => {

    $('.js-homepage-shop-categories-tab').on('click', handleTabClick);

    $(window).on('resize', (event) => {
      if (window.innerWidth > breakpoint) {
        if (shopyBySlidersAreMobile) {
          initShopBySliders();
          shopyBySlidersAreMobile = false;
        }
      } else {
        if (!shopyBySlidersAreMobile) {
          shopyBySlidersAreMobile = true;
        }
      }
    });
  };

  const cacheDom = () => {
    $dom.homeHeroSlider = $('.js-homepage-hero-slider-container');
    $dom.homeShopSlider = $('.js-homepage-shop-categories-product-slider-container');
    $dom.homeReviewsSlider = $('.js-home-reviews-slider-content-container');
    $dom.homeBlogSlider = $('.js-homepage-blog-post-slider-container');
  };

  const initShopBySliders = () => {
    $dom.homeShopSlider.slick(shopSliderOptions);
  };

  const bindSliderEvents = () => {
    $dom.homeHeroSlider.on('beforeChange', sliderBeforeChange);
    $dom.homeHeroSlider.on('afterChange', sliderAfterChange);
  };

  const initSliders = () => {
    $dom.homeHeroSlider.slick(heroSliderOptions);
    $dom.homeShopSlider.slick(shopSliderOptions);
    $dom.homeReviewsSlider.slick(reviewsSliderOptions);
    $dom.homeBlogSlider.slick(blogSliderOptions);
  };
  
  HomepageSlidersTabs.init = () => {
    bindUIActions();
    cacheDom();
    bindSliderEvents();
    initSliders();
    initTabsAndShopAllButton();
  };
  
  const sliderBeforeChange = (event, slick, currentSlide, nextSlide) => {
    let $slick = slick['$slider'],
        $currentSlide = $slick.find('[data-slick-index="'+currentSlide+'"]'),
        $currentSlideVideo = $currentSlide.find('.js-homepage-hero-slider-full-width-video');
    if($currentSlideVideo.length > 0) {
      $currentSlideVideo.get(0).pause();
    }
  };
  
  const sliderAfterChange = (event, slick, currentSlide) => {
    let $slick = slick['$slider'],
        $currentSlide = $slick.find('[data-slick-index="'+currentSlide+'"]'),
        $currentSlideVideo = $currentSlide.find('.js-homepage-hero-slider-full-width-video');
    if($currentSlideVideo.length > 0) {
      let promise = $currentSlideVideo.get(0).play();
      if(promise !== undefined) {
        promise
          .then(_ => {})
          .catch(error => {
            $currentSlideVideo.hide();
          });
      }
    }
  };

})(window.HomepageSlidersTabs = window.HomepageSlidersTabs || {}, jQuery);